import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * PWA install prompt. Shows a floating banner on supported browsers (Android Chrome, Edge).
 * iOS Safari does not expose beforeinstallprompt; we hide the banner there (user installs via Share menu).
 */
export default function InstallPwaBanner() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pnc_pwa_dismissed")) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    // Also hide if already installed
    const installedHandler = () => setVisible(false);
    window.addEventListener("appinstalled", installedHandler);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") {
      setVisible(false);
    }
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem("pnc_pwa_dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-pwa-banner"
      className="fixed bottom-24 sm:bottom-6 inset-x-4 sm:inset-x-auto sm:right-6 z-50 max-w-sm mx-auto sm:mx-0 animate-slide-up"
    >
      <div className="pnc-card !rounded-2xl p-4 flex items-center gap-3 shadow-2xl border-emerald-500/30">
        <div className="w-10 h-10 shrink-0 rounded-xl bg-emerald-500/20 text-emerald-300 flex items-center justify-center">
          <Download className="w-5 h-5" strokeWidth={2.4} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-white">Instale o Põe na Conta</p>
          <p className="text-[11px] text-slate-400">Acesso rápido direto do celular, sem navegador.</p>
        </div>
        <button
          data-testid="pwa-install-btn"
          onClick={install}
          className="shrink-0 px-3 py-2 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-slate-900 text-xs font-bold"
        >Instalar</button>
        <button
          onClick={dismiss}
          aria-label="Fechar"
          className="shrink-0 w-7 h-7 rounded-full bg-slate-800/60 text-slate-400 hover:text-white flex items-center justify-center"
        ><X className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
}
